import { requests } from '@/libs/axios/axios'
import { OrganizationsEndpoints } from '../organizations-endpoints'

async function getOrganizationLicenses(id: number) {
  return requests.get(`${OrganizationsEndpoints.ORGANIZATIONS}/${id}/license`)
}

export default getOrganizationLicenses
